<template>
  <div class="main">
    <!-- header -->
    <top-pc></top-pc>

    <myDetail v-if="$route.name === 'detail'"></myDetail>
    <template v-if="$route.name === 'home-pc'">
      <!-- banner -->
      <div class="banner">
        <img class="image" src="http://7n.m-visitor.medsci.cn/ean_banner1.png" alt />
      </div>

      <!-- 内容 -->
      <div class="content">
        <!-- 导航栏 -->
        <div class="nav">
          <div class="item" @click="golist(5)">
            <img class="image" src="./../../assets/pc/shenjingjirou.png" alt />
            <div class="text">神经肌肉疾病专区</div>
          </div>
          <div class="item" @click="golist(6)">
            <img class="image" src="./../../assets/pc/shenjingmianyi.png" alt />
            <div class="text">神经免疫性疾病专区</div>
          </div>
          <div class="item" @click="golist(7)">
            <img class="image" src="./../../assets/pc/shenjingtuixing.png" alt />
            <div class="text">神经退行性疾病专区</div>
          </div>
          <div class="item checked" @click="golist(8)">
            <span>2020EAN快速注册</span>
            <span>》》</span>
          </div>
        </div>

        <!-- 大会日程模块 -->
        <!-- <div class="box"> -->
          <!-- 标题 -->
          <!-- <div class="title">
            <div class="image">
              <img class="image" src="./../../assets/pc/richeng-logo.png" alt />
            </div>
            <div class="title">大会日程</div>
            <div class="more" @click="goMore">
              MORE
              <svg-icon class="svgIcon" icon-class="right"></svg-icon>
            </div>
          </div> -->

          <!-- 大会日程内容 -->
          <!-- <div class="detail">
            <div class="left" @click="goArticle(first_schedule.id,first_schedule.link_url)">
              <div class="image">
                <img :src="first_schedule.cover" alt />
              </div>
              <div class="left-title">{{first_schedule.title}}</div>
              <div class="time">{{first_schedule.release_time}}</div>
              <div class="description">{{first_schedule.describe}}</div>
            </div>
            <div class="right">
              <template v-for="(item,index) in other_schedule">
                <div class="card" :key="index" @click="goArticle(item.id)">
                  <div class="image">
                    <img :src="item.cover?item.cover:'./../../assets/pc/list-bg.png'" alt />
                  </div>
                  <div class="right-title">{{item.title}}</div>
                  <div class="time">{{item.release_time}}</div>
                </div>
              </template>
            </div>
          </div> -->
        <!-- </div> -->

        <!-- 热点速递模块 -->
        <list-pc 
          title="热点速递" 
          :logo="redian" 
          :value="3" 
          :model="index_data.express"
        ></list-pc>

        <!-- 专家解读模块 -->
        <list-pc
          title="专家解读"
          :logo="zhuanjia"
          :value="4"
          :model="index_data.unscramble"
        ></list-pc>

        <!-- 神经肌肉疾病模块 -->
        <list-pc 
          title="神经肌肉疾病" 
          :logo="jirou" 
          :value="5" 
          :model="index_data.muscle"
        ></list-pc>

        <!-- 神经免疫性疾病模块 -->
        <list-pc 
          title="神经免疫性疾病" 
          :logo="mianyi" 
          :value="6" 
          :model="index_data.immune"
        ></list-pc>

        <!-- 神经退行性疾病模块 -->
        <list-pc 
          title="神经退行性疾病" 
          :logo="tuixing" 
          :value="7" 
          :model="index_data.retrogression"
        ></list-pc>
      </div>
    </template>
  </div>
</template>

<script>
import topPc from "./top-pc";
import listPc from "./list-pc";
import myDetail from './../detail'

import redian from "./../../assets/pc/redian-logo.png";
import zhuanjia from "./../../assets/pc/zhuanjia-logo.png";
import jirou from "./../../assets/pc/jirou-logo.png";
import mianyi from "./../../assets/pc/mianyi-logo.png";
import tuixing from "./../../assets/pc/tuixing-logo.png";

export default {
  name: "home-pc",
  components: {
    topPc,
    listPc,
    myDetail
  },
  data() {
    return {
      checked: 5,
      redian,
      zhuanjia,
      jirou,
      mianyi,
      tuixing,
      index_data: {},
      first_schedule: {},
      other_schedule: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 获取数据
    async getData() {
      const res = await this.api.news_index({ type: "web" });
      this.index_data = res.data ? res.data : {};
      this.first_schedule = this.index_data.schedule[0];
      this.other_schedule = this.index_data.schedule.splice(1);
    },

    // 跳转更多列表
    goMore() {
      this.$store.dispatch("change_active", 2);
      this.$router.push({
        path: "/detail",
        query: {
          id: 2
        }
      });
    },

    goArticle(id,url) {
      this.$store.dispatch("change_active", 2);
      if(url) {
        // 如果有外链 跳转外链
        window.location.href = url
        return;
      }
      this.$router.push({
        path: "/article",
        query: {
          id
        }
      });
    },

    // 跳转快速通道
    golist(id) {
      if(id === 8) {
        window.location.href = 'https://my.ean.org/s/login/SelfRegister?startURL=%2Fs%2Fcongress'
        return
      }
      this.checked = id
      this.$store.dispatch("change_active", id);
      this.$router.push({
        path: '/detail',
        query: {
          id
        }
      })
    }
  }
};
</script>

<style lang='scss' scoped>
.banner {
  .image {
    width: 100%;
  }
}

.content {
  width: 1178px;
  margin: 0 auto;

  // 导航样式
  .nav {
    margin: 33px 0;
    display: flex;
    justify-content: space-between;

    // 导航元素样式
    .item {
      background: rgba(247, 247, 247, 1);
      border-radius: 7px;
      width: 290px;
      height: 101px;
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(16, 16, 16, 1);
      padding: 20px 0px 20px 20px;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 60px 1fr;
      grid-column-gap: 15px;
      align-items: center;

      // 导航图片样式
      .image {
        width: 60px;
        height: 60px;
        vertical-align: middle;
      }

      // 导航标题样式
      .text {
        width: 190px;
      }
    }

    .item:last-child {
      width: 229px;
      padding-left: 0;
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 30px 30px;
      justify-items: center;
    }

    // 选中样式
    .checked {
      background: #3372cc;
      color: #fff;
    }
  }

  // 大会日程模块
  .box {
    padding-bottom: 40px;

    // 标题样式
    .title {
      height: 70px;
      width: 1178px;
      background: #f5f5f5;
      border-radius: 10px;
      display: flex;
      line-height: 70px;
      margin-bottom: 30px;

      .image {
        width: 70px;
        position: relative;

        .image {
          width: 32px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .title {
        flex: 1;
        color: #101010;
        font-size: 24px;
        font-weight: 600;
      }

      .more {
        flex: 1;
        font-size: 22px;
        color: #aaa;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .svgIcon {
          font-size: 32px;
        }
      }
    }

    // 内容详情样式
    .detail {
      display: grid;
      grid-template-columns: 600px 1fr;
      grid-column-gap: 20px;

      .left {
        display: grid;
        grid-column: 1/2;
        grid-template-rows: 402px 25px 22px 46px;
        grid-row-gap: 18px;

        .image {
          grid-column: 1/2;
          grid-row: 1/2;
          width: 100%;

          img {
            width: 100%;
            height: 100%;
            border-radius: 10px;
          }
        }

        .left-title {
          grid-column: 1/2;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(50, 50, 50, 1);
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }

        .time {
          grid-column: 1/2;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(170, 170, 170, 1);
          width: 100%;
        }

        .description {
          grid-column: 1/2;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(170, 170, 170, 1);
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }

      .right {
        grid-column: 2/3;

        .card {
          width: 100%;
          padding: 18px 0 16px;
          display: grid;
          grid-template-columns: 165px 370px;
          grid-template-rows: 60px 22px;
          grid-column-gap: 20px;
          grid-row-gap: 28px;
          border-bottom: 1px solid #f7f7f7;

          .image {
            grid-column: 1/2;
            grid-row: 1/3;

            img {
              width: 100%;
              height: 100%;
              border-radius: 10px;
            }
          }

          .right-title {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 400;
            color: rgba(50, 50, 50, 1);
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .time {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            color: rgba(170, 170, 170, 1);
          }
        }

        .card:first-child {
          padding-top: 0;
        }

        .card:last-child {
          padding-bottom: 0;
          border-bottom: none;
        }
      }
    }
  }
}
</style>